import defaultAttributes from '../defaultAttributes';

const SignalZero = [
  'svg',
  defaultAttributes,
  [['path', { d: 'M2 20h.01' }], ['path', { d: 'M7 20v-4' }]],
];

export default SignalZero;
